<template>
  <div>
    <div class="mb-1">{{ label }}</div>
    <div class="d-sm-flex">
      <v-autocomplete
        v-if="!hideDay"
        ref="dayField"
        v-bind="$attrs"
        v-model="day"
        :items="days.filter((d) => d.value <= daysInMonth(month, year))"
        label="Jour"
        style="width: 100px"
        class="flex-grow-0 mr-2 mb-2 mb-sm-0"
        @input="handleChange"
        :rules="basicDayRules"
        :outlined="isOutlined"
        :dense="isDense"
        :disabled="disabled"
        auto-select-first
        :error="(!conditionRespectee || !isDateInRange) && valid"
        hide-details
      ></v-autocomplete>

      <v-autocomplete
        ref="monthField"
        v-bind="$attrs"
        v-model="month"
        :items="months"
        label="Mois"
        style="width: 140px"
        class="flex-grow-0 mr-2 mb-2 mb-sm-0"
        @input="handleChange"
        :rules="basicMonthRules"
        :outlined="isOutlined"
        :dense="isDense"
        :disabled="disabled"
        auto-select-first
        :error="(!conditionRespectee || !isDateInRange) && valid"
        hide-details
      ></v-autocomplete>
      <v-autocomplete
        ref="yearField"
        v-bind="$attrs"
        v-model="year"
        :items="years"
        label="Année"
        style="width: 100px"
        class="flex-grow-0"
        @input="handleChange"
        :rules="basicYearRules"
        :outlined="isOutlined"
        :dense="isDense"
        :disabled="disabled"
        auto-select-first
        :error="(!conditionRespectee || !isDateInRange) && valid"
        hide-details
      ></v-autocomplete>
      <v-btn v-if="valid && !disabled" icon text class="ml-1" @click="clear"><v-icon>mdi-close</v-icon></v-btn>
    </div>
    <div v-if="valid && !isDateInRange" class="error--text">{{ dateRangeMessage }}</div>
    <v-checkbox
      class="list_counter_validator my-2 ml-6 p-0"
      v-if="valid && !isDateInRange"
      :input-value="isDateInRange"
      :rules="[(v) => !!v]"
    ></v-checkbox>
    <div v-if="!conditionRespectee" class="error--text">{{ conditionMessage }}</div>
    <v-checkbox
      class="list_counter_validator my-2 ml-6 p-0"
      v-if="!conditionRespectee"
      :input-value="conditionRespectee"
      :rules="[(v) => optional || !!v]"
    ></v-checkbox>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
export default {
  props: {
    label: { type: String },
    isBirthdate: { type: Boolean, default: false },
    hideDay: Boolean,
    minValue: {
      type: String,
      default: null
    },
    maxValue: {
      type: String,
      default: null
    },
    optional: Boolean,
    value: {
      type: String
    },
    disabled: { type: Boolean, default: false },
    condition: { type: Function, required: false },
    conditionMessage: { type: String }
  },

  data() {
    return {
      year: null,
      month: null,
      day: null,
      years: [],
      months: [],
      days: [],
      updating: false,
      dateRegex: /\d{4}-\d{2}-\d{2}/
    }
  },

  created() {
    this.setYears()
    this.months.push({ text: "Janvier", value: "01" })
    this.months.push({ text: "Février", value: "02" })
    this.months.push({ text: "Mars", value: "03" })
    this.months.push({ text: "Avril", value: "04" })
    this.months.push({ text: "Mai", value: "05" })
    this.months.push({ text: "Juin", value: "06" })
    this.months.push({ text: "Juillet", value: "07" })
    this.months.push({ text: "Aout", value: "08" })
    this.months.push({ text: "Septembre", value: "09" })
    this.months.push({ text: "Octobre", value: "10" })
    this.months.push({ text: "Novembre", value: "11" })
    this.months.push({ text: "Décembre", value: "12" })

    for (let j = 1; j <= 31; j++) {
      this.days.push({
        text: j,
        value: j < 10 ? "0" + j.toString() : j.toString()
      })
    }
    this.setValues(this.value)
  },

  computed: {
    ...mapGetters(["isOutlined", "isDense"]),
    minYearInner() {
      if (this.minValue) {
        return parseInt(this.minValue.substring(0, 4))
      }
      if (this.isBirthdate) {
        return new Date().getFullYear() - 100
      }
      return 2000
    },
    maxYearInner() {
      if (this.maxValue) {
        return parseInt(this.maxValue.substring(0, 4))
      }
      if (this.isBirthdate) {
        return new Date().getFullYear() - 15
      }
      return new Date().getFullYear() + 6
    },
    isDateInRange() {
      if (!this.valid) return true
      
      const selectedDate = new Date(this.stringValue)
      
      if (this.minValue) {
        const minDate = new Date(this.minValue)
        if (selectedDate < minDate) return false
      }
      
      if (this.maxValue) {
        const maxDate = new Date(this.maxValue)
        if (selectedDate > maxDate) return false
      }
      
      return true
    },
    dateRangeMessage() {
      if (!this.minValue && !this.maxValue) return ""
      if (this.minValue && this.maxValue) {
        return `La date doit être entre le ${this.formatDate(this.minValue)} et le ${this.formatDate(this.maxValue)}`
      }
      if (this.minValue) {
        return `La date doit être après le ${this.formatDate(this.minValue)}`
      }
      return `La date doit être avant le ${this.formatDate(this.maxValue)}`
    },
    basicYearRules() {
      return [
        (v) => this.optional || this.years.indexOf(v) > -1 || "Année"
      ]
    },
    basicMonthRules() {
      return [
        (v) => this.optional || this.months.map((m) => m.value).indexOf(v) > -1 || "Mois"
      ]
    },
    basicDayRules() {
      return [
        (v) => this.hideDay || this.optional || this.days.map((d) => d.value).indexOf(v) > -1 || "Jour"
      ]
    },
    yearRules() {
      return [
        (v) => this.optional || this.years.indexOf(v) > -1 || "Année",
        () => this.isDateInRange || this.dateRangeMessage
      ]
    },
    monthRules() {
      return [
        (v) => this.optional || this.months.map((m) => m.value).indexOf(v) > -1 || "Mois",
        () => this.isDateInRange || this.dateRangeMessage
      ]
    },
    dayRules() {
      return [
        (v) => this.hideDay || this.optional || this.days.map((d) => d.value).indexOf(v) > -1 || "Jour",
        () => this.isDateInRange || this.dateRangeMessage
      ]
    },
    valid() {
      return this.dateRegex.test(this.stringValue)
    },
    stringValue() {
      if (this.year == null && this.month == null && this.day == null) {
        return null
      }
      return `${this.year}-${this.month}-${this.hideDay ? "01" : this.day}`
    },
    conditionRespectee() {
      if (typeof this.condition == "function") {
        return this.condition(this.stringValue)
      }
      return true
    }
  },

  methods: {
    daysInMonth(month, year) {
      return new Date(year, month, 0).getDate()
    },
    setYears() {
      this.years = []
      for (let a = this.minYearInner; a < this.maxYearInner; a++) {
        this.years.push(a.toString())
      }
    },
    handleChange() {
      let day = Math.min(parseInt(this.day), this.daysInMonth(this.month, this.year)).toString()
      this.day = day < 10 ? "0" + day : day
      if (this.valid) {
        this.$emit("input", this.stringValue)
      }
      
      // Force validation on all date fields when any component changes
      this.$nextTick(() => {
        if (this.$refs.dayField) this.$refs.dayField.validate()
        if (this.$refs.monthField) this.$refs.monthField.validate()
        if (this.$refs.yearField) this.$refs.yearField.validate()
      })
    },
    setValues(value) {
      if (value) {
        let match = value.match(/([0-9]{4})-([0-9]{2})-([0-9]{2})/)
        if (match) {
          this.year = match[1]
          this.month = match[2]
          this.day = match[3]
        }
      }
    },
    clear() {
      this.day = null
      this.month = null
      this.year = null
      this.$emit("input", null)
    },
    setValue(date) {
      let stringDate = date.toLocaleDateString("fr-CA")
      this.setValues(stringDate)
      this.handleChange()
    },
    formatDate(dateStr) {
      const date = new Date(dateStr)
      return date.toLocaleDateString("fr-FR", { year: "numeric", month: "long", day: "numeric" })
    }
  }
}
</script>

<style>
</style>